<div style="height:100vh;background-color: rgb(185, 190, 200);display:flex;justify-content:center;align-items:center;">
    <div class="card form-signin">
        <div *ngIf='!_resetFormService.forgotPasswordShow'>
            <div class="card-header new-logo text-black">
                <div class="cbob-new-logo-container text-center">
                    <img src="./assets/img/CBOB-Official-Logo-SM.jpg" class="cbob-new-logo">
                    <!--limagecss-->
                    <h2 class="small">Welcome to the Bond Portal</h2>

                </div>

            </div><br>
            <!-- <h4 class="small">One-time enrolment for new users</h4> -->
            <button mat-flat-button class="w-100" color="accent" [routerLink]="['/enroll']">Click here for New User Sign Up</button><br><br>
            <button mat-flat-button class="w-100" color="accent" >Returning Users Login</button><br>
           <div class="card-body">

                <form name="loginUser" [formGroup]="loginUser" (ngSubmit)="login(loginUser.value)"
                    style="border: transparent;">
                     <mat-form-field class="w-100">
                        <mat-label>Enter NIB Number </mat-label>
                        <input matInput name="NIBNumber" type="number" class="example-right-align"
                            formControlName="NIBNumber" onKeyPress="if(this.value.length==8) return false;"
                            autocomplete="off">
                        <mat-error *ngIf="loginUser.controls.NIBNumber.invalid">
                            Please Enter NIB Number
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="w-100">
                        <mat-label>Enter Password</mat-label>
                        <input matInput name="Password" type="password" formControlName="Password"
                            placeholder="Enter Password">
                        <mat-error *ngIf="loginUser.controls.Password.invalid">
                            Please Enter Password
                        </mat-error>
                    </mat-form-field>
                    <button mat-flat-button class="w-100 loginbtn mb-2" type="submit" color="primary">Save/Login</button>
                    <button mat-flat-button class="w-100 mb-2" color="warn" type="button"
                        (click)="_resetFormService.forgottenPasswordFormUpdate(true, $event)">Forgot Password? Click here
                    </button>
                    <!-- <button mat-flat-button class="w-100" color="accent" [routerLink]="['/enroll']">Enrol</button> -->


                </form>
            </div>
        </div>
        <!-- </div> -->
        <div class="animated fadeIn" *ngIf="_resetFormService.forgotPasswordShow">

            <forgot-password></forgot-password>

        </div>

    </div>